export interface EnergyStoneModel {
  id: number;
  name: string;
  description: string;
  price: number;
  imageUrl: string;
  nodeLevel: number;
  isPurchased: boolean;
}

export interface BuyStoneBody {
  stoneId: number;
}

export interface BuyStoneResponse {
  ok: boolean;
  message: string;
}

export enum StoneTagType {
  STONES = 'Stones',
}
